import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import { SupplierWithId } from '../../../models/supplier.model';
import { ROUTES } from '../../../common/constants/routes';
import { ProfileRow } from '../../../common/profiles-list/ProfileRow';
import { CATEGORY_CARD_ACCENTS } from '../../../common/category-card/types';

type SupplierRowProps = {
  supplier: SupplierWithId;
  navigateToDocs: (id: number) => void;
  handleEdit: (id: number) => void;
  handleDelete: (id: number) => void;
};

export const SupplierRow: React.FC<SupplierRowProps> = ({
  supplier,
  navigateToDocs,
  handleDelete,
  handleEdit,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <ProfileRow
      idPrefix='supplierRow'
      profileId={supplier.id}
      title={supplier.name ?? ''}
      icon={<BusinessCenterOutlinedIcon />}
      accent={CATEGORY_CARD_ACCENTS.Suppliers}
      details={[
        {
          id: 'supplierRowEmailCell',
          icon: <MailOutlinedIcon fontSize='inherit' />,
          label: t('labels.email'),
          value: supplier.supplier_email,
        },
        {
          id: 'supplierRowWebsiteCell',
          icon: <LanguageOutlinedIcon fontSize='inherit' />,
          label: t('labels.website'),
          value: supplier.website,
        },
        {
          id: 'supplierRowRegistrationNumberCell',
          icon: <BadgeOutlinedIcon fontSize='inherit' />,
          label: t('formInputs.registrationNumberInputLabel'),
          value: supplier.registration_number,
        },
      ]}
      onOpen={() => navigate(`${ROUTES.SUPPLIER_PROFILES}/${supplier.id}`)}
      onDocuments={() => navigateToDocs(supplier.id)}
      onEdit={() => handleEdit(supplier.id)}
      onDelete={() => handleDelete(supplier.id)}
    />
  );
};
